
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { ColorScheme } from "@/lib/singularity/brand/colors/types";
import { getColorSchemeLabel } from "@/lib/singularity/brand/colors/utils";

@Component({
  components: {
    Icon
  }
})
export default class ColorSchemeCard extends Vue {
  @Prop({ required: true })
  scheme!: ColorScheme;

  @Prop({ required: true })
  schemeString!: string;

  @Prop({ default: false })
  isSelected!: boolean;

  get shadeLabel(): string {
    return getColorSchemeLabel(this.scheme, this.schemeString);
  }

  get previewStyle() {
    return {
      "--card-bg": this.scheme.background.value?.toString(),
      "--card-text": this.scheme.contrastedFromBackgroundForText.value?.toString()
    };
  }

  select() {
    this.$emit("select");
  }
}
